import { client } from '../client';
import { ClientTag, UserRoleName } from './types/UserProfile';

export interface IClientTag {
  nodes: ClientTag[];
}

/**
 * Lists client tags accessible to the current user.
 *
 * - Care Advisor → GET /care_advisor/clients
 * - Collector → GET /collector/clients
 * - Provider → GET /provider/clients
 * - Super Admin → GET /superadmin/clients
 * - All other roles → GET /admin/clients
 */
export const listAllClientTags = async (
  userRole?: UserRoleName,
): Promise<IClientTag> => {
  const rolePrefixes: Partial<Record<UserRoleName, string>> = {
    [UserRoleName.CareAdvisor]: '/care_advisor',
    [UserRoleName.Collector]: '/collector',
    [UserRoleName.Provider]: '/provider',
    [UserRoleName.SuperAdmin]: '/superadmin',
    [UserRoleName.Admin]: '/admin',
  };

  const prefix = (userRole && rolePrefixes[userRole]) || '/admin';
  const { data } = await client.get<IClientTag>(`${prefix}/clients`);

  return data;
};